<template>
  <div id="filtroClientes">
    <b-row class="pt-3 pb-2" id="headerPageCli">
      <b-col sm="10 title" class="pl-0">{{title || "Título não informado"}}</b-col>
      <b-col sm="2" v-if="pageCliente" class="pr-0"><b-button size="sm" class="btn-plus btnAdicionar left" :style="cor" v-on:click="adicionar()"><i class="fas fa-plus"></i> Adicionar</b-button></b-col>
      <b-col sm="2" v-if="pagePedido" class="pr-0"><b-button size="sm" class="btn-plus btnVoltar left" :style="cor" v-on:click="voltar()"><i class="fas fa-arrow-left"></i> Voltar</b-button></b-col>
    </b-row>
    <b-row class="input-search filtro shadow p-2" id="filtroWeb">
      <b-col cols="5">
        <b-input-group>
          <b-input-group-prepend>
            <span class="input-group-text"><i class="fa fa-search"></i></span>
          </b-input-group-prepend>
          <b-form-input size="sm" :placeholder="placeholderNm" v-model="termo" autocomplete="no">
          </b-form-input>
        </b-input-group>
      </b-col>
      <b-col cols="2" class="p-0">
        <b-form-select size="sm" v-model="uf" @change="onChange($event)">
          <template slot="first"><option value="" disabled>-- UF --</option></template>
          <option v-for="uf in options" :value="uf" :key="uf">{{uf}}</option>
        </b-form-select>
      </b-col>
      <b-col cols="3">
        <b-input-group>
          <b-input-group-prepend>
            <span class="input-group-text"><i class="fa fa-search"></i></span>
          </b-input-group-prepend>
          <b-form-input size="sm" :placeholder="placeholderCid" v-model="cidade" autocomplete="no">
          </b-form-input>
        </b-input-group>
      </b-col>
      <b-col cols="2" class="pl-0">
        <b-button class="btnLimpaFiltro defaultColor" size="sm" v-on:click="limparFiltro()"><i class="fas fa-eraser"></i></b-button>
        <b-button class="btnBuscaFiltro defaultColor" size="sm" v-on:click="filtrar()"><i class="fas fa-search"></i></b-button>
      </b-col>
    </b-row>
    <b-row class="input-search filtro shadow" id="filtroMob">
      <b-button id="abreModalFiltro" size="sm" v-on:click="abreModalFiltro()"><i class="fas fa-search mr-2"></i>Filtrar</b-button>
      <b-button class="ml-3 btnLimpaFiltro" size="sm" v-on:click="limparFiltro()"><i class="fas fa-eraser mr-2"></i>Limpar Filtro</b-button>
    </b-row>
    <b-modal
      v-model="modalFiltro"
      ok-title="Filtrar"
      ok-variant="primary"
      cancel-title="Cancelar"
      cancel-variant="secondary"
      @ok="filtrar"
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5>Filtrar Clientes</h5>
      </template>
      <form>
        <div class="form-row m-0">
          <div class="w-100">
            <b-input-group>
              <b-input-group-prepend class="mt-0">
                <span class="input-group-text"><i class="fa fa-search"></i></span>
              </b-input-group-prepend>
              <b-form-input size="sm" :placeholder="placeholderNm" v-model="termo" autocomplete="no">
              </b-form-input>
            </b-input-group>
          </div>
          <div class="form-row w-100 mt-3 ml-0 mr-0">
            <div class="col-3 pl-0">
              <b-form-select size="sm" v-model="uf" @change="onChange($event)">
                <template slot="first"><option value="" disabled>-- UF --</option></template>
                <option v-for="uf in options" :value="uf" :key="uf">{{uf}}</option>
            </b-form-select>
            </div>
            <div class="col-9 pr-0">
              <b-input-group>
                <b-input-group-prepend class="mt-0">
                  <span class="input-group-text"><i class="fa fa-search"></i></span>
                </b-input-group-prepend>
                <b-form-input size="sm" :placeholder="placeholderCid" v-model="cidade" autocomplete="no">
                </b-form-input>
              </b-input-group>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
  import clientes from '@/services/tableClientes'
  import { broadcastServer, operacao, modo } from '@/main'
  import { mapState } from 'vuex'
  export default {
    name: 'NewItemsClientesVue',
    props: [
      'title',
      'placeholderNm',
      'placeholderCid',
      'escondeBtn'
    ],
    computed: {
      ...mapState({
        cor: state => {
          const { cor } = state.cor
          return {
            'background-color': cor
          }
        },
        corSelecionado: state => {
          const { corSelecionado } = state.cor
          console.log(corSelecionado)
          return {
            'background-color': corSelecionado
          }
        }
      })
    },
    data () {
      return {
        pageCliente: true,
        pagePedido: false,
        clientes: clientes,
        uf: '',
        termo: '',
        cidade: '',
        options: [
          'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'
        ],
        modalFiltro: false,
        headerTextVariant: 'light',
        headerBgVariant: 'dark'
      }
    },
    created () {
      broadcastServer.$on('parametrosSelecionadosCliente', (parametros) => {
        this.uf = parametros.uf
        this.termo = parametros.termo
        this.cidade = parametros.cidade
      })
    },
    mounted () {
      broadcastServer.$on('esconderBotaoAdicionarCliente', param => {
        this.pageCliente = false
        this.pagePedido = true
      })
    },
    methods: {
      adicionar: function () {
        let parametro = {operacao: operacao.ADICIONAR, modo: modo.EDICAO}
        broadcastServer.$emit('pageEditClientes', parametro, '')
      },
      voltar: function () {
        broadcastServer.$emit('exibirLista')
      },
      filtrar: function () {
        this.modalFiltro = false
        let termoSemMascara = this.termo.replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '')
        let parametros = {termo: termoSemMascara, uf: this.uf, cidade: this.cidade}
        // console.log(JSON.stringify(parametros))
        broadcastServer.$emit('parametrosSelecionadosCliente', parametros)
      },
      limparFiltro: function () {
        this.termo = ''
        this.uf = ''
        this.cidade = ''
        let parametros = {termo: this.termo, uf: this.uf, cidade: this.cidade}
        // console.log(JSON.stringify(parametros))
        broadcastServer.$emit('parametrosSelecionadosCliente', parametros)
      },
      onChange (index) {
        this.statusSelecionado = this.options[index]
        this.codStatus = this.statusSelecionado
      },
      abreModalFiltro: function () {
        this.modalFiltro = true
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/items/NewItemsClientesVue.vue